module.exports = __webpack_public_path__ + "img/letter_bg.f4c3eb5d.png";